exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "dl.infoRow-f88245d5{margin:0;min-height:22px}dl.infoRow-f88245d5 dt{font-weight:bold;float:left;width:160px;overflow:hidden;text-align:right;text-overflow:ellipsis;white-space:nowrap}dl.infoRow-f88245d5 dd{margin-left:180px}\n", ""]);

// Exports
exports.locals = {
	"infoRow": "infoRow-f88245d5"
};